import * as React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import { Box, Typography, Grid } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { generateTransactionChartPayload } from "./libs/generateRevenueChartPayload";

const chartSettings = {
  xAxis: [
    {
      scaleType: "band",
      dataKey: "created_at",
    },
  ],
  yAxis: [
    {
      scaleType: "linear",
    },
  ],
  height: 220,
};

const TransactionChart = ({ data, height = null }) => {
  const { selectedFacility } = useSelector((state) => state.stationList);
  const { selectedDate } = useSelector((state) => state.datePicker);
  const [transactionDates, setTransactionDates] = useState([]);
  if (height) chartSettings.height = height;

  const { t } = useTranslation();

  useEffect(() => {
    if (data?.view_facility_revenue_aggregate?.nodes) {
      (async () => {
        const newData = await generateTransactionChartPayload(
          data.view_facility_revenue_aggregate.nodes,
          selectedDate?.start?.toISOString(),
          selectedDate?.end?.toISOString()
        );
        setTransactionDates(newData);
      })();
    }
  }, [data, selectedDate, selectedFacility]);

  return (
    <Box
      bgcolor={"white"}
      p={3}
      borderRadius={"16px"}
      padding={"24px 24px 8px"}
    >
      <Typography variant="subtitle" fontWeight="600">
        {t("chargingSessions")}
      </Typography>
      <Grid container flexDirection="column">
        <Grid item display="flex">
          <Grid
            item
            display="flex"
            alignItems="center"
            sx={{ transform: "rotate(-90deg)" }}
            fontSize="12px"
            fontWeight="600"
            textTransform="uppercase"
          >
            {t("sessions")}
          </Grid>
          <LineChart
            dataset={transactionDates}
            {...chartSettings}
            series={[{ dataKey: "count", color: "#467CEB" }]}
          />
        </Grid>
        <Grid
          item
          display="flex"
          justifyContent="center"
          fontSize="12px"
          fontWeight="600"
          textTransform="uppercase"
        >
          {t("date")}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TransactionChart;
